import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import moveConversationToFocusedOrOther from '../conversations/moveConversationToFocusedOrOther';
import moveItemsToFocusedOrOther from '../items/moveItemsToFocusedOrOther';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { ActionSource } from 'owa-analytics-actions';

export default async function moveMailListRowsToFocusedOrOtherAction(
    rowKeys: string[],
    originalTableViewId: string,
    toViewFilter: FocusedViewFilter,
    actionSource?: ActionSource
) {
    const tableView = listViewStore.tableViews.get(originalTableViewId);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            await moveConversationToFocusedOrOther(
                rowKeys,
                originalTableViewId,
                toViewFilter,
                actionSource
            );
            break;

        case ReactListViewType.Message:
            await moveItemsToFocusedOrOther(
                rowKeys,
                originalTableViewId,
                toViewFilter,
                actionSource
            );
            break;
    }
}
